import React from 'react';
import styles from './style.module.scss';
import CloseIcon from 'components/icon/close-icon';
import { testIds } from 'constants/test-constants';
import { useTranslation } from 'next-i18next';
import { LOCALE_MODAL_PATHS, Namespaces } from 'types/locales';

const NoImageListingsFilterWarning = ({
  onClose,
  showNoImageListingsFilterWarning,
  isModal = false,
}) => {
  const { t } = useTranslation(Namespaces.MODAL);

  const handleClose = e => {
    const warningElement = e.target.closest(`.${styles['modal-more-filters-button-warning']}`);
    if (warningElement) {
      warningElement.classList.add(styles['hidden']);
    }
    if (onClose) onClose();
  };

  return (
    <> 
      { !isModal ? (
        showNoImageListingsFilterWarning && (
          <div className={styles['more-filters-button-warning']} data-testid={testIds.warningPopupContainer}>
            <p>
              {t(LOCALE_MODAL_PATHS.FILTER_WARNINGS_NO_IMAGE_LISTINGS_HIDDEN, {
                defaultValue: 'Listings without images have been hidden. Click "More Filters" to edit it.',
              })}
            </p>
            <CloseIcon className={styles['close-button']} onClick={handleClose} testId={testIds.warningPopupCloseIcon}/>
          </div>
        )
      ) : (
        showNoImageListingsFilterWarning && (
          <div className={styles['modal-more-filters-button-warning']} data-testid={testIds.warningPopupContainer}>
            <p>
              {t(LOCALE_MODAL_PATHS.FILTER_WARNINGS_CLICK_TO_SHOW_NO_IMAGE_LISTINGS, {
                defaultValue: 'Click here to show listings without images',
              })}
            </p>
            <CloseIcon className={styles['close-button']} onClick={handleClose} testId={testIds.warningPopupCloseIcon}/>
          </div>
        )
      )}
    </>
  );
};

export default NoImageListingsFilterWarning;
